import { render, staticRenderFns } from "./Estatisticas.vue?vue&type=template&id=1e420164&scoped=true&"
import script from "./Estatisticas.vue?vue&type=script&lang=js&"
export * from "./Estatisticas.vue?vue&type=script&lang=js&"
import style0 from "./Estatisticas.vue?vue&type=style&index=0&id=1e420164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e420164",
  null
  
)

export default component.exports